__turbopack_context__.v({
  "countryCode": "CompactPhoneNumberField-module-scss-module__c_p4tW__countryCode",
  "countryCodeBid": "CompactPhoneNumberField-module-scss-module__c_p4tW__countryCodeBid",
  "dialCode": "CompactPhoneNumberField-module-scss-module__c_p4tW__dialCode",
  "field": "CompactPhoneNumberField-module-scss-module__c_p4tW__field",
  "fieldError": "CompactPhoneNumberField-module-scss-module__c_p4tW__fieldError",
  "fieldInline": "CompactPhoneNumberField-module-scss-module__c_p4tW__fieldInline",
  "flag": "CompactPhoneNumberField-module-scss-module__c_p4tW__flag",
  "hpv2Blink": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2Blink",
  "hpv2DemoBounce": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2DemoBounce",
  "hpv2DemoFadeIn": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2DemoFadeIn",
  "hpv2DemoProgress": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2DemoProgress",
  "hpv2DemoScaleIn": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2DemoSlideIn",
  "hpv2FadeLeft": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2FadeLeft",
  "hpv2FadeRight": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2FadeRight",
  "hpv2FadeUp": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2FadeUp",
  "hpv2FloatA": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2FloatA",
  "hpv2FloatB": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2FloatB",
  "hpv2HeroFadeIn": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2PriceShimmer",
  "hpv2PulseDot": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2PulseDot",
  "hpv2ScaleUp": "CompactPhoneNumberField-module-scss-module__c_p4tW__hpv2ScaleUp",
  "inputRow": "CompactPhoneNumberField-module-scss-module__c_p4tW__inputRow",
  "label": "CompactPhoneNumberField-module-scss-module__c_p4tW__label",
  "phoneInput": "CompactPhoneNumberField-module-scss-module__c_p4tW__phoneInput",
  "phoneInputBid": "CompactPhoneNumberField-module-scss-module__c_p4tW__phoneInputBid",
  "phoneInputError": "CompactPhoneNumberField-module-scss-module__c_p4tW__phoneInputError",
});
